import { OnboardingKey } from '../types/types';

export interface OnboardingDefinition {
	selector: string;
	headline: string;
	details?: string;
	textAlign?: 'center' | 'left' | 'right';
	position: string;
}

export interface UrlToOnboardingKeyMapping {
	startsWith?: string;
	exactMatch?: string;
	contains?: string;
	regExp?: RegExp;
	onboardingKey: OnboardingKey;
}
